import { downloadZipExport } from "#modules/quoteRequests/infra/downloadZipExport";

export const downloadExportConsultation = async ({
  quoteId,
  quoteRequestLineIds,
}: {
  quoteId: string;
  quoteRequestLineIds: string[];
}): Promise<void> => {
  await downloadZipExport({
    url: `/quotes/${quoteId}/exports-consultation`,
    body: { quoteRequestLineIds: quoteRequestLineIds.length > 0 ? quoteRequestLineIds : undefined },
    filename: `consultation-${quoteId}.zip`,
  });
};
